import './sidebar-list.scss';

import { isEmpty } from 'lodash';

import { CustomFormattedMessage } from '../intl/custom-formatted-message';

type SidebarListProps = {
  loading?: boolean;
  items: JSX.Element[];
};

export function SidebarList({ loading, items }: SidebarListProps) {
  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="sidebar-list">
      {items.map(option => (
        <div key={option.key} className="sidebar-list__item">
          {option}
        </div>
      ))}
    </div>
  );
}
